export const wpdata = state => {
  return state.wpdata;
}

export const getInitialAnalyseData = state => (language) => {
  return state.wpdata[language].analyse[0].shop_analyse_options[0];
}

export const getInitialCameraData = state => (language) => {
  state.available = state.wpdata[language].camera[0].shop_camera_options[0].shop_camera_options_available;
  if(state.available === true){
    let currentDate = new Date();
    state.delivery_type = 'now'
    state.delivery_date = currentDate.toISOString().slice(0, 10);
    currentDate.setDate( currentDate.getDate() + 14 );
    state.delivery_date_min = currentDate.toISOString().slice(0, 10);
    currentDate.setMonth( currentDate.getMonth() + 6 );
    state.delivery_date_max = currentDate.toISOString().slice(0, 10);
  }else{
    state.delivery_type = 'date'
    state.delivery_date = state.wpdata[language].camera[0].shop_camera_options[0].shop_camera_options_available_from;
    state.delivery_date_min = state.wpdata[language].camera[0].shop_camera_options[0].shop_camera_options_available_from;
    let maxDate = new Date(state.delivery_date_min);
    let currentDate = new Date();
    if(maxDate > currentDate){
      maxDate.setMonth( maxDate.getMonth() + 6 );
      state.delivery_date_max = maxDate.toISOString().slice(0, 10);
    }else{
      currentDate.setMonth( currentDate.getMonth() + 6 );
      state.delivery_date_max = currentDate.toISOString().slice(0, 10);
    }
  }
  return state.wpdata[language].camera[0].shop_camera_options[0];
}



// WEBPACK FOOTER //
// ./src/store/getters.js